import "./Socials.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import socialsData from "./SocialsData";

const Socials = () => (
  <ul className="socials__list">
    {socialsData.map(({ name, icon, color, href, order }) => (
      <li
        key={name}
        className="socials__item"
        style={{ "--i" : order,"--clr": color }}
      >
        <a className="socials__link" href={href} target="_blank">
          <span className="socials__label">
            <FontAwesomeIcon icon={icon} />
          </span>
          {name}
        </a>
      </li>
    ))}
  </ul>
);

export default Socials;